// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.5.1_webpack@5.106.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.5.1_webpack@5.106.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-a29cfb3a],.fade-leave-active[data-v-a29cfb3a]{pointer-events:none;transition:opacity .2s ease}.fade-enter-from[data-v-a29cfb3a],.fade-leave-to[data-v-a29cfb3a]{opacity:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
